import { Card, DonutChart, Flex, Metric, Text } from '@tremor/react';
import React from 'react'

function OverallSentimentCard({ fragment, t, sentimentTranslations, mapSentimentAndColors, speakerNames, ...rest }) {
    return (
        <Card className='max-h-full f' data-testid="overall-sentiment-card" {...rest}>
            {fragment.result ?
                <div className="max-w-full">
                    <Flex alignItems="start">
                        <Text>{t('ExpandedMeedingCard.OverallSentimentLavel')}</Text>

                    </Flex>
                    <Flex className="space-x-3 truncate" justifyContent="start" alignItems="baseline">
                        <Metric>{sentimentTranslations((Object.keys(JSON.parse(fragment.result))[0] || "Sentiments"), t('Language'))}</Metric>
                    </Flex>

                    <DonutChart
                        className="mt-6 max-h-32"
                        data={
                            Object.entries(JSON.parse(fragment.result)).map(([key, value]) => {
                                return { name: sentimentTranslations(key, t('Language')), value: parseFloat(value) };
                            })
                        }
                        category="value"
                        index="name"
                        colors={
                            Object.entries(JSON.parse(fragment.result)).map(([key, value]) => (
                                mapSentimentAndColors(key) ? mapSentimentAndColors(key) : "black"
                            ))
                        }
                        showAnimation={true}
                        variant='pie'
                    />
                    <div className='w-full flex justify-center items-center'>
                        {(() => {
                            console.error('🚨🚨🚨 OVERALL SENTIMENT CARD LEGEND RENDERING 🚨🚨🚨');
                            console.error('📊 Fragment result:', fragment.result);
                            
                            // Add aggressive defensive parsing
                            let parsedResult;
                            try {
                                parsedResult = JSON.parse(fragment.result);
                                console.error('✅ Successfully parsed fragment result:', parsedResult);
                            } catch (error) {
                                console.error('❌ OVERALL SENTIMENT CARD - JSON parse error:', error);
                                return <div className="text-red-500 italic">Failed to parse sentiment data</div>;
                            }
                            
                            if (!parsedResult || typeof parsedResult !== 'object') {
                                console.error('❌ OVERALL SENTIMENT CARD - Invalid parsed result:', parsedResult);
                                return <div className="text-red-500 italic">Invalid sentiment data structure</div>;
                            }
                            
                            const entries = Object.entries(parsedResult);
                            console.error('📋 OVERALL SENTIMENT CARD entries:', entries);
                            
                            const categories = entries.map(([key, value]) => {
                                const category = (sentimentTranslations(key, t('Language'))) + " (" + value + "%)";
                                console.error(`🏷️ OVERALL SENTIMENT CARD Category for ${key}:`, category);
                                return category;
                            });
                            
                            const colors = entries.map(([key, value]) => {
                                const color = mapSentimentAndColors(key) ? mapSentimentAndColors(key) : "black";
                                console.error(`🎨 OVERALL SENTIMENT CARD Color for ${key}:`, color);
                                return color;
                            });
                            
                            console.error('✅ OVERALL SENTIMENT CARD - Rendering Legend with categories:', categories, 'colors:', colors);
                            
                            // Use custom legend instead of Tremor Legend to prevent Chart.js errors
                            console.error('✅ SENTIMENT CARD - Using CUSTOM LEGEND to bypass Tremor/Chart.js issues');
                            
                            return (
                                <div className="mt-3 flex flex-wrap justify-center gap-x-4 gap-y-2">
                                    {entries.map(([key, value], index) => (
                                        <div key={index} className="flex items-center gap-2">
                                            <div 
                                                className={`w-3 h-3 rounded bg-${colors[index] || 'gray-500'}`}
                                            ></div>
                                            <span className="text-sm text-gray-700">
                                                {categories[index]}
                                            </span>
                                        </div>
                                    ))}
                                </div>
                            );
                        })()}
                    </div>
                </div> : <div className='min-w-full h-32 bg-gray-200 animate-pulse'></div>}
        </Card>
    )
}

export default OverallSentimentCard
